import { UiSocialLoginSignupButtonModel } from "../../models";

export function mockUiSocialLoginSignupButtonModel({
    id = "button-1234",
    type = "uiSocialLoginSignupButton",
    locale = "en",
    content = mockUiSocialLoginSignupButtonModelContent()
}: Partial<UiSocialLoginSignupButtonModel> = {}): UiSocialLoginSignupButtonModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiSocialLoginSignupButtonModelContent =
    UiSocialLoginSignupButtonModel["content"];

export function mockUiSocialLoginSignupButtonModelContent({
    entryTitle = "Example Social Login Signup Button",
    providerName = "google",
    buttonText = "Continue with Google",
    ...optionals
}: Partial<UiSocialLoginSignupButtonModelContent> = {}): UiSocialLoginSignupButtonModelContent {
    return {
        entryTitle,
        providerName,
        buttonText,
        ...optionals
    };
}
